export type CatalogChoice = { skillId: string; label: string; subject?: string; grade?: number; topic?: string };

export function filterChoices<T extends CatalogChoice>(choices: T[], query: string, subject: string, grade: string) {
  const words = query.toLocaleLowerCase("de").trim().split(/\s+/).filter(Boolean);
  return choices.filter((item) => (!subject || item.subject === subject) && (!grade || item.grade === Number(grade)) &&
    words.every((word) => `${item.label} ${item.topic ?? ""}`.toLocaleLowerCase("de").includes(word)))
    .sort((a, b) => (a.grade ?? 0) - (b.grade ?? 0) || a.label.localeCompare(b.label, "de"));
}

// Keep the full API int64 range without JavaScript Number precision loss.
export function validSeed(value: string): boolean {
  return /^\d{1,19}$/.test(value) && BigInt(value) <= 9223372036854775807n;
}
